import { type FC } from 'react';

import { SupportChatRootLazy } from 'dibs-support-chat/exports/SupportChatRootLazy.ts';
import { useSupportChatType } from 'dibs-support-chat/exports/useSupportChatType.ts';

const SupportChat: FC = () => {
    const chatType = useSupportChatType();

    if (!chatType) {
        return null;
    }

    return <SupportChatRootLazy type={chatType} />;
};

export { SupportChat };
